"use client";

import React from "react";
import Image from "next/image";
import DOMPurify from "dompurify";
import { getImageURL } from "@/helpers/imageURLHelper";

const ModalCarouselItem = ({
  slide,
  index,
  display,
  handleSlideChange,
  onClose,
  ntd = false,
}) => {
  const sanitizedCaptionHtml = DOMPurify.sanitize(slide?.caption);
  return (
    <div
      className="reveal-overlay tps-gallery-modal-overlay"
      style={{ display: display ? "flex" : "none" }}
    >
      <div
        id={`gallery-modal-${index}`}
        className="reveal gallery-modal"
        role="dialog"
        aria-hidden="false"
        data-yeti-box={`gallery-modal-${index}`}
        data-resize={`gallery-modal-${index}`}
        data-i="51tqac-i"
        tabIndex="-1"
        style={{
          display: display ? "block" : "none",
          alignContent: "center",
          top: "-100px",
        }}
      >
        <button
          className="close-button"
          data-close=""
          type="button"
          onClick={onClose}
          style={{
            display: "block",
            position: "relative",
            margin: "0 0 0 auto",
            padding: "20px 0",
          }}
        >
          <span className="sr-only">Close video modal</span>×
        </button>
        <div className="tps-gallery-modal-item-wrapper">
          <a
            href="#"
            className="tps-gallery-modal-control"
            data-gallery-dir="prev"
            data-gallery-array-id={`galleryItems_${index}`}
            data-target-item-id={`gallery_item_id_${index}`}
            data-target-item-index={`${index}`}
            onClick={(e) => handleSlideChange(e, "previous")}
          >
            <span className="sr-only">
              previous image
              <span />
            </span>
          </a>
          <Image
            className="tps-gallery-modal-item-image"
            src={getImageURL(
              ntd ? slide : slide?.formats?.large?.url || slide?.url,
              ntd
            )}
            alt={slide?.alternativeText ? slide?.alternativeText : ""}
            width={slide?.formats?.large?.width || slide?.width}
            height={slide?.formats?.large?.height || slide?.height}
          />
          <a
            href="#"
            className="tps-gallery-modal-control"
            data-gallery-dir="next"
            data-gallery-array-id={`galleryItems_${index}`}
            data-target-item-id={`gallery_item_id_${index}`}
            data-target-item-index={`${index}`}
            onClick={(e) => handleSlideChange(e, "next")}
          >
            <span className="sr-only">
              next image
              <span />
            </span>
          </a>
          {!!slide.caption && (
            <div
              className="tps-gallery-modal-item-text"
              dangerouslySetInnerHTML={{ __html: sanitizedCaptionHtml }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalCarouselItem;
